import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/commands/")({
  beforeLoad: () => {
    throw redirect({ href: "/admin/operations" });
  },
});
